module.exports = __webpack_public_path__ + "img/nr.d2d585c3.jpg";